import { Component, OnInit, Input } from "@angular/core";
@Component({
    selector: "dodo-tooltip",
    templateUrl: "./tooltip.component.html",
    styleUrls: ["./tooltip.component.scss"],
    standalone: false
})
export class DodoTooltipComponent implements OnInit {
	@Input() iconImage: string;
	@Input() text: string;
	@Input() content: string;
	@Input() position = "left";
	public showContent = false;
	constructor() {}
	ngOnInit() {}
	public closeTooltip() {
		this.showContent = false;
	}
}
